import React from 'react';
import Pagination from 'rc-pagination';
import _en_US from 'rc-pagination/lib/locale/en_US';

// material ui
import Checkbox from '@material-ui/core/Checkbox';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
//import SettingsIcon from '@material-ui/icons/Settings';
//import SortIcon from '@material-ui/icons/Sort';

import AppActions from '../../actions/app-actions';
import AppConstants from '../../constants/app-constants';
import Loader from '../common/loader';
import DeviceListItem from './devicelistitem';
import AppStore from '../../stores/app-store';
import { advanceOnboarding, getOnboardingStepCompleted } from '../../utils/onboardingmanager';

import {getColumnHeaders} from './helper';
import TextField from '@material-ui/core/TextField';

export default class DeviceList extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      expandedDeviceId: null,
      sortedUUID: false,
      sortedHB: false,
      globalSettings: AppStore.getGlobalSettings(),
      columnHeaders: getColumnHeaders(props.type)
    };

    /** Bind methods */
    this._expandRowBind = this._expandRow.bind(this);
    this._onRowSelectionBind = this._onRowSelection.bind(this);
    this._onChangeBind = this._onChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    AppStore.changeListener(this._onChangeBind);
    const deviceId = this.props?.redirect?.id;
    if(deviceId !== undefined && deviceId !== '') {
      const filteredDevices = this.props.devices.filter(item => item.identity_data?.UUID === deviceId);
      if(filteredDevices.length > 0) {
        const expandedId = filteredDevices[0].id;
        this.setState({expandedDeviceId: expandedId});
      }
    }
  }

  componentDidUpdate(prevProps) {
    var self = this;
    const { group } = self.props;

    if (prevProps.group !== group) {
      self.setState({ textfield: group ? decodeURIComponent(group) : 'All devices' });
    }
  }

  componentWillUnmount() {
    AppStore.removeChangeListener(this._onChangeBind);
  }

  _onChange(type) {
    if (type === AppConstants.SET_GLOBAL_SETTINGS) {
      const globalSettings = AppStore.getGlobalSettings();
      this.setState(() => ({globalSettings}));
    }
  }

  _expandRow(e, expanded) {
    if (this.props.updateRefreshTimer) {
      this.props.updateRefreshTimer(!expanded);
    }
    if (e.currentTarget && e.currentTarget.parentElement) {
      const idx = parseInt(e.currentTarget.parentElement.getAttribute('deviceidx'));
      let deviceId = this.props.devices[idx].id;
      AppActions.setSnackbar('');
      if (this.state.expandedDeviceId === deviceId) {
        deviceId = null;
      }
      if (!AppStore.getOnboardingComplete() && getOnboardingStepCompleted('devices-pending-accepting-onboarding')) {
        advanceOnboarding('devices-accepted-onboarding');
      }
      this.setState({ expandedDeviceId: deviceId });
    }
  }

  _isSelected(index) {
    return this.props.onSelect && this.props.selectedRows.indexOf(index) !== -1;
  }

  _toggleSortingOrder(name){
    if (name === 'UUID'){
      this.setState({sortedUUID: !this.state.sortedUUID}, () =>{
        var order = {UUID: this.state.sortedUUID, heart_beat:this.state.sortedHB};
        AppStore.setSortingOrder(order);
        this.props.refreshDevices();
      });

    } else if(name === 'last_checkin') {

      this.setState({sortedHB: !this.state.sortedHB }, ()=>{
        var order = {UUID: this.state.sortedUUID, heart_beat:this.state.sortedHB};
        AppStore.setSortingOrder(order);
        this.props.refreshDevices();
      });
      this.props.refreshDevices();
    }
  }

  _onRowSelection(e) {
    const { onSelect, selectedRows } = this.props;
    const selectedRow = parseInt(e.target.getAttribute('deviceidx'));
    const selectedIndex = selectedRows.indexOf(selectedRow);
    let updatedSelection = [];
    if (selectedIndex === -1) {
      updatedSelection = updatedSelection.concat(selectedRows, selectedRow);
    } else {
      selectedRows.splice(selectedIndex, 1);
      updatedSelection = updatedSelection.concat(selectedRows);
    }
    onSelect(updatedSelection);
  }

  onSelectAllClick() {
    const self = this;
    let selectedRows = Array.apply(null, { length: this.props.devices.length }).map(Number.call, Number);
    if (self.props.selectedRows.length && self.props.selectedRows.length <= self.props.devices.length) {
      selectedRows = [];
    }
    self.props.onSelect(selectedRows);
  }

  onPageChange(page) {
    this.props.onPageChange(page);
    this.setState({ expandedDeviceId: null });
  }

  filterDevices(devices, columnHeaders) {
    let filterDevices = devices;
    const filterColumns = columnHeaders?.filter(column => column.filter);
    filterColumns?.forEach(column => {
      const { filter } = column;
      filterDevices = Array.from(devices).filter(device => {
        const value = column.property ? device[column.property] : column.render(device);
        return value.toLowerCase().includes(filter.toLowerCase());
      });
    });
    return filterDevices;
  }

  onFilterChange(filter, filteredColumn) {
    const newFilterColumns = this.state.columnHeaders
      .map(column => column.id === filteredColumn.id ? { ...column, filter } : column);
    this.setState({columnHeaders: newFilterColumns})
  }

  render() {
    const self = this;
    const { className, devices, pageLength, pageLoading, pageNo, pageTotal, onSelect } = self.props;
    const {selectedRows, ...propsToChild} = self.props;
    const { expandedDeviceId } = self.state;
    const numSelected = (selectedRows || []).length;
    const filteredDevices = this.filterDevices(devices, this.state.columnHeaders);

    return (
      <div className={`deviceList ${className || ''}`}>
        <div className="flexbox header" style={{ padding: '0 12px', height: 110 }}>
          {
            onSelect
              ? (
                <Checkbox
                  indeterminate={numSelected > 0 && numSelected < devices.length}
                  checked={numSelected === devices.length}
                  onChange={() => self.onSelectAllClick()} />
              )
              : null
          }
          {this.state.columnHeaders.map(item => (
            <div key={item.name} style={Object.assign({ padding: '0 15px', width: '-webkit-fill-available' }, item.style)}>
              <div className="columnHeader" >
                {item.title}
                {
                  item.isSortable && item.name === 'UUID'
                    ? self.state.sortedUUID
                      ? <ArrowDropDownIcon onClick={self._toggleSortingOrder.bind(this, item.name)} style={{ fontSize: 25, marginLeft: '5px' }} />
                      : <ArrowDropUpIcon onClick={self._toggleSortingOrder.bind(this, item.name)} style={{ fontSize: 25, marginLeft: '5px' }} />
                    : null
                }
              </div>
              {
                item.filter !== undefined
                  ? <TextField
                    type='search'
                    label={item.filterLabel}
                    value={item.filter}
                    onChange={e => this.onFilterChange(e.target.value, item)}
                    style={{ marginTop: 0, minWidth: 0, width: '-webkit-fill-available', maxWidth: item.filterMaxWidth }} />
                  : null
              }
            </div>
          ))}
          <div style={{ width: 48 }} />
        </div>
        <div className="body">
          {filteredDevices.map((device, index) => (
            <DeviceListItem
              {...propsToChild}
              device={device}
              expanded={expandedDeviceId === device.id}
              key={device.id}
              idx={index}
              selectable={!!onSelect}
              selected={self._isSelected(index)}
              onClick={this._expandRowBind}
              onRowSelect={this._onRowSelectionBind}
              globalSettings={this.state.globalSettings}
            />
          ))}
        </div>
        <Pagination
          className="margin-top"
          locale={_en_US}
          simple
          pageSize={pageLength}
          current={pageNo}
          total={pageTotal}
          onChange={e => self.onPageChange(e)}
        />
        {pageLoading ? (
          <div className="smallLoaderContainer">
            <Loader show={true} />
          </div>
        ) : null}
      </div>
    );
  }
}
